import React, { useState } from 'react'
import { Layout } from 'antd'
import 'antd/dist/antd.css'


import HeadComponent from '../../components/header'
import ContentCompoent from '../../components/content'
import SidebarComponent from '../../components/sidebar'

const { Header, Content, Sider } = Layout;

/**
 * 主页面，涵盖Header Sider Content。
 * 
 */
export default function HomeIndex(props) {
    sessionStorage.setItem('langValue',0)
  let [breadCrumbArr, setBreadCrumbArr] = useState([]);
  return (
    <div>
      <Layout theme="light">
        <Header className="header" theme="light" style={{ backgroundColor: '#fefefe', height: '90px', padding: '0', 'boxShadow': '0px 3px 20px 0px #edeff2' }}>
          <HeadComponent {...props} />
        </Header>
        <Layout>
          <Sider className="site-layout-background" theme="light">
            {/* useState如果用到数组，更新值要拷贝副本才生效 */}
            <SidebarComponent {...props} setBreadCrumb={(arr) => {
              setBreadCrumbArr([...arr]);
            }} />
          </Sider>

          <Layout >
            {/* //主体功能区 */}
            <Content
              className="site-layout-background"
              style={{
                padding: '1rem',
                margin: 0,
                minHeight: 280,
              }}
            >
              < ContentCompoent {...props} breadCrumbArr={breadCrumbArr} />
            </Content>
          </Layout>
        </Layout>
      </Layout>
    </div>
  );
}
